import { __decorate } from "tslib";
import PdpDisplay from "@/components/pdp/PdpDisplay.vue";
import { Component, Vue } from "vue-facing-decorator";
let PdpConsultScreen = class PdpConsultScreen extends Vue {};
PdpConsultScreen = __decorate([Component({
  components: {
    PdpDisplay
  }
})], PdpConsultScreen);
export default PdpConsultScreen;